import { useMemo } from 'react';

import { ColorModel, FilterOption } from '@common/models';
import {
    ColorFilters,
    filterAllEntries,
    generateFilters,
    getSelectedFiltersMap,
    initializeFiltersOptions,
} from '@core/components/filters/filterUtils';
import useColors from '@ee-api/colors-api/useColors';
import { useAppSelector } from '@redux/hooks';
import { selectColorFilters } from '@redux/slices/colorSlice';

type useFilteredColorsReturn = {
    filteredColors: ColorModel[];
    colorFilters: ColorFilters;
};

// TODO: consolidte with useFilteredSinks
const useFilteredColors = (): useFilteredColorsReturn => {
    const { colors } = useColors();
    const _colorFilters = useAppSelector(selectColorFilters);

    const initialFilterOptions: ColorFilters = useMemo(() => {
        let initialFilters: ColorFilters = {};
        const setColorFilters = (val: ColorFilters) => {
            initialFilters = val;
        };
        if (colors.length > 0) {
            initializeFiltersOptions(colors, setColorFilters);
        }
        return initialFilters;
    }, [colors]);

    const colorFilters = useMemo(() => {
        if (!_colorFilters || !Object.keys(_colorFilters).length) {
            return initialFilterOptions;
        }

        return generateFilters(colors, _colorFilters);
    }, [_colorFilters, colors, initialFilterOptions]);

    const filteredColors = useMemo(() => {
        const selectedFilters: Map<string, FilterOption[]> = getSelectedFiltersMap(colorFilters);
        return filterAllEntries(Array.from(selectedFilters.entries()), colors, true);
    }, [colorFilters, colors]);

    return {
        filteredColors,
        colorFilters,
    };
};

export default useFilteredColors;
